export const RACE_TRANSLATIONS = {
    'Other': 'Otro',
    'South Asian': 'Asiático del Sur',
    'White/European American': 'Blanco/Americano Europeo',
    'Black/African American': 'Negro/Afroamericano',
    'Jewish': 'Judío',
    'American Indian/Native American': 'Indio Americano/Nativo Americano',
    'Pacific Islander': 'Isleño del Pacífico',
    'Asian/Asian American': 'Asiático/Asiático Americano',
    'Middle Eastern': 'Medio Oriente',
    'Hispanic/Latino(a)': 'Hispano/Latino(a)',
    'Unknown / Undisclosed': 'Desconocido / No revelado',
    'Bi-racial/Multi-Racial': 'Biracial/Multirracial'
};

export const EMPLOYMENT_STATUS_TRANSLATIONS = {
    'Unemployed': 'Desempleado',
    'Unemployed – not receiving benefits': 'Desempleado – sin recibir beneficios',
    'Self-employed': 'Autónomo',
    'Full time employment': 'Empleo a tiempo completo',
    'Active Military': 'Militar activo',
    'Retired': 'Jubilado',
    'Student': 'Estudiante',
    'Part time employment': 'Empleo a tiempo parcial',
    'Unemployed – receiving benefits': 'Desempleado – recibiendo beneficios',
    'Employed': 'Empleado'
};

export const GENDER_TRANSLATIONS = {
    'Prefer to self-describe': 'Prefiero autodescribirme',
    'Unknown': 'Desconocido',
    'Female': 'Femenino',
    'Prefer not to disclose': 'Prefiero no divulgar',
    'Non-binary': 'No binario',
    'Male': 'Masculino'
};
